import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'
import { Tooltip } from '@mui/material'

export const CustomButton = styled(ButtonMui)`
  width: 16rem;    
  height: 2.8rem !important;
  margin: 0 !important;
`

export const ContainerButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 .5rem .5rem 0;
  gap: 1rem;
`

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`

export const CustomTooltip = styled(Tooltip)``
